import { render, staticRenderFns } from "./AssetsOnOdex.vue?vue&type=template&id=fddd5ec6&"
import script from "./AssetsOnOdex.vue?vue&type=script&lang=js&"
export * from "./AssetsOnOdex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports